/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {ListMenuContent} from './list-menu-content'
import {Box, Text, useMultiStyleConfig, Fade} from '@chakra-ui/react'
import {getGlobalLink} from '../../utils/contentstack-utils'

const ListMenuPopover = ({
    primarycategory,
    categoriesData,
    selectedMenuItem,
    setSelectedMenuItem,
    onItemClick,
}) => {
    const isOpen = selectedMenuItem === primarycategory.uid

    const styles = useMultiStyleConfig('KenwoodMenu')

    const {url, label, isAbsolute} = getGlobalLink({
        link: primarycategory?.redirects,
        categoriesData,
    })

    return (
        <Box>
            <Box {...styles.listMenuTriggerContainer}>
                <Box
                    {...styles.listMenuTriggerGroup}
                    onClick={() => {
                        if (isOpen) {
                            setSelectedMenuItem()
                        } else {
                            setSelectedMenuItem(primarycategory.uid)
                        }
                    }}
                >
                    <Text
                        {...styles.listMenuTriggerLink}
                        sx={isOpen ? styles.listMenuTriggerLinkActive : {}}
                        {...{name: label + ' __'}}
                    >
                        {label}
                    </Text>
                </Box>
            </Box>
            {isOpen && (
                <>
                    <Box {...styles.popoverOverlay} onClick={() => setSelectedMenuItem(null)} />
                    <Fade
                        in={isOpen}
                        style={{position: 'absolute', top: '100%', zIndex: -1, left: 0, right: 0}}
                        transition={{exit: {delay: 1}, enter: {duration: 0.5}}}
                    >
                        <Box {...styles.listMenuContent}>
                            <ListMenuContent
                                secondLevel={primarycategory?.second_level}
                                categoriesData={categoriesData}
                                categoryUrl={url}
                                isCategoryUrlAbsoulte={isAbsolute}
                                onItemClick={onItemClick}
                            />
                        </Box>
                    </Fade>
                </>
            )}
        </Box>
    )
}

ListMenuPopover.propTypes = {
    categoriesData: PropTypes.object,
    primarycategory: PropTypes.object,
    selectedMenuItem: PropTypes.string,
    setSelectedMenuItem: PropTypes.func,
    onItemClick: PropTypes.func,
}

export {ListMenuPopover}
